import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {EditAddressComponent} from './edit-address.component';
import {AutocompleteInputModule} from '../../../../../components/common/autocomplete-input/autocomplete-input.module';
import {SelectFilterModule} from '../../../../../components/common/select-filter/select-filter.module';
import {ExpandedCardModule} from '../../../../../components/common/expanded-card/expanded-card.module';
import {FormFieldModule} from '../../../../core/component/form-field/form-field.module';
import {InputTextModule} from '../../../../core/component/input-text/input-text.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        AutocompleteInputModule,
        SelectFilterModule,
        ExpandedCardModule,
        FormFieldModule,
        InputTextModule,
    ],
    exports: [
        EditAddressComponent
    ],
    declarations: [
        EditAddressComponent,
    ]
})
export class EditAddressModule {}